import type { AuthorizationError } from '../services/api';

/** Map a backend error to a data-field-anchor target. */
export function errorToAnchor(error: AuthorizationError): string {
  if (error.visit_id) return `visit-${error.visit_id}`;
  if (error.authorization_id) return `auth-${error.authorization_id}`;
  return 'auth-unlinked';
}
